import { env as envConfig } from 'features/common/config/envConfig';
import { TenantApplicationNode } from 'features/context-ids/types/types';
import { useGetTenantsQuery } from 'gql/graphql';
import { useMemo } from 'react';

export const useGetApplicationNodes = () => {
  const { data, loading, error } = useGetTenantsQuery({
    variables: {
      first: 100,
      env: envConfig,
    },
  });

  const { applicationsNodes, rawNodes, hasTenantsData } = useMemo(() => {
    const nodes = data?.user?.applications?.nodes || [];

    return {
      rawNodes: nodes,
      applicationsNodes: nodes.map((node) => ({
        id: node.id,
        annotations:
          node.annotations?.map((a) => ({
            key: a.key,
            value: a.value,
          })) || [],
      })),
      hasTenantsData: nodes.length > 0,
    };
  }, [data]);

  return {
    applicationsNodes,
    isLoading: loading,
    error,
    rawNodes,
    hasTenantsData,
  };
};
